if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);

      // Mesmo comportamento do tema, mas com checagem extra
      if (this.productInfo && window.Shopify && Shopify.postLinksRetry) {
        this.productInfo.initShareLinks();
      }

      // 🔹 Tentar reagir à mudança de variante (se o tema disparar esse evento)
      if (this.productInfo) {
        this.productInfo.addEventListener('variant:change', (event) => {
          const variant = event.detail && event.detail.variant;
          if (!variant || !variant.featured_media) return;

          const mediaId = `${this.dataset.section}-${variant.featured_media.id}`;
          this.setActiveMedia(mediaId, true);
        });
      }

      // Se nem viewer existe, não faz nada
      if (!this.elements.viewer) return;

      // Se não tiver thumbnails, ainda deixa o viewer funcionar (setas, swipe etc.)
      if (typeof debounce === 'function') {
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );
      }

      // Configura clique nas thumbnails, se existirem
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          // Usa o button se existir, senão o próprio <li>
          const clickable = mediaToSwitch.querySelector('button') || mediaToSwitch;

          clickable.addEventListener('click', () => {
            const targetId = mediaToSwitch.dataset.target;
            if (!targetId) return;
            this.setActiveMedia(targetId, false);
          });
        });

        if (this.dataset.desktopLayout &&
            this.dataset.desktopLayout.includes('thumbnail') &&
            this.mql.matches) {
          this.removeListSemantic();
        }
      }
    }

    onSlideChanged(event) {
      if (!this.elements.thumbnails || !event.detail || !event.detail.currentElement) return;

      const mediaId = event.detail.currentElement.dataset.mediaId;
      if (!mediaId) return;

      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      if (!this.elements.viewer) return;

      const activeMedia = this.elements.viewer.querySelector(
        `[data-media-id="${mediaId}"]`
      );

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      if (!activeMedia) return;
      activeMedia.classList.add('is-active');

      if (prepend) {
        if (activeMedia.parentElement) {
          activeMedia.parentElement.prepend(activeMedia);
        }
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          if (activeThumbnail && activeThumbnail.parentElement) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        if (this.elements.viewer.slider && this.elements.viewer.resetPages) {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (this.elements.thumbnails && activeMedia.parentElement) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${mediaId}"]`
      );
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) =>
        element.removeAttribute('aria-current')
      );

      const btn = thumbnail.querySelector('button') || thumbnail;
      btn.setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        return;
      }

      if (this.elements.thumbnails.slider) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      if (!this.elements.liveRegion) return;

      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;

      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if (window.pauseAllMedia) window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && deferredMedia.loadContent) {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer || !this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  });
}
